module.exports = __webpack_public_path__ + "static/media/close.ded36178.svg";